import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=2776be6a&scoped=true&"
import script from "./ViewTicket.vue?vue&type=script&lang=js&"
export * from "./ViewTicket.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicket.vue?vue&type=style&index=0&id=2776be6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2776be6a",
  null
  
)

export default component.exports